// คำนวณเรขาคณิตของวงล้อ: ช่อง i กินมุม [i*s, (i+1)*s) วัดตามเข็มนาฬิกาจากตำแหน่ง 12 นาฬิกา
// ตัวชี้อยู่ที่ 12 นาฬิกา -> วงล้อต้องหมุนตามเข็ม θ ≡ -(กลางช่อง) จึงจะหยุดตรงช่องที่ชนะ

export function polar(cx, cy, r, angleDeg) {
  const a = (angleDeg * Math.PI) / 180;
  return [cx + r * Math.sin(a), cy - r * Math.cos(a)];
}

export function slicePath(cx, cy, r, fromDeg, toDeg) {
  const [x0, y0] = polar(cx, cy, r, fromDeg);
  const [x1, y1] = polar(cx, cy, r, toDeg);
  const large = toDeg - fromDeg > 180 ? 1 : 0;
  return `M${cx} ${cy}L${x0.toFixed(2)} ${y0.toFixed(2)}A${r} ${r} 0 ${large} 1 ${x1.toFixed(2)} ${y1.toFixed(2)}Z`;
}

// องศาที่ต้องหมุนเพิ่ม (รวมหมุนเต็มรอบ + jitter ในช่อง) เพื่อให้ช่อง winningIndex มาหยุดที่ตัวชี้
export function rotationForIndex(winningIndex, count, currentDeg, rand = Math.random) {
  const sector = 360 / count;
  const normalized = ((currentDeg % 360) + 360) % 360;
  const target = -(winningIndex * sector + sector / 2);
  const delta = (((target - normalized) % 360) + 360) % 360;
  const spins = Math.floor(rand() * 6) + 10;
  const jitterLimit = Math.max(0, sector / 2 - 3);
  const jitter = (rand() - 0.5) * 2 * jitterLimit;
  return 360 * spins + delta + jitter;
}

// ช่องที่อยู่ใต้ตัวชี้เมื่อวงล้อหมุนไป totalDeg
export function sliceUnderPointer(totalDeg, count) {
  const sector = 360 / count;
  const a = (((-totalDeg) % 360) + 360) % 360;
  return Math.floor(a / sector) % count;
}
